module.exports = __webpack_public_path__ + "6943a5b137d44f7166e4e2bc0fb964a8.jpeg";